import api from '@/api/index.js'

const account_props = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null,
    availableTypes: ['generic', 'owner'],
  },

  mutations: {
    SET_ACCOUNT_PROPS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_PROPS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_PROPS: (state, data) => {
      state.data = data
      state.loading = false
      state.updating = false
    },
    SET_ACCOUNT_PROPS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    },
  },

  actions: {
    LoadAccountProps({commit}, id) {
      commit('SET_ACCOUNT_PROPS', [])
      commit('SET_ACCOUNT_PROPS_ERROR', null)
      commit('SET_ACCOUNT_PROPS_LOADING', true)
      return api.get(`accounts/${id}/props`)
        .then((response) => {
          commit('SET_ACCOUNT_PROPS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_PROPS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateAccountProps({commit}, payload) {
      commit('SET_ACCOUNT_PROPS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_ACCOUNT_PROPS_UPDATING', true)
      return api.post(`accounts/${payload.accountId}/props`, payload.data)
        .then((response) => {
          commit('SET_ACCOUNT_PROPS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_PROPS_ERROR', error)
          commit('SET_ACCOUNT_PROPS_UPDATING', false);
        })
    },
    UpdateAccountProps({commit}, payload) {
      commit('SET_ACCOUNT_PROPS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_ACCOUNT_PROPS_UPDATING', true)
      return api.put(`accounts/${payload.accountId}/props/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_ACCOUNT_PROPS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_PROPS_ERROR', error)
          commit('SET_ACCOUNT_PROPS_UPDATING', false);
        })
    },
    DeleteAccountProps({commit}, payload) {
      commit('SET_ACCOUNT_PROPS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_ACCOUNT_PROPS_UPDATING', true)
      return api.delete(`accounts/${payload.accountId}/props/${payload.id}`)
        .then((response) => {
          commit('SET_ACCOUNT_PROPS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_PROPS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_PROPS_UPDATING', false);
        })
    }
  },
}

export default account_props
